
let _text = 'Server is unavailable at this moment. Please call our 24/7 support to finish your transaction.';

export function setLastResortErrorMessage(text) {
  _text = text;
}

export function getLastResortErrorMessage() {
  return _text;
}